module.exports = __webpack_public_path__ + "static/cely_rose_noel_bebe-b03a3a91195a88ac648a44a90b4ed81f.jpg";